import React from "react"
import { Box, IconButton, Hidden } from "@mui/material"
import { makeStyles } from "makeStyles"
import Icon from "@mdi/react"
import { mdiViewGrid, mdiFormatListBulleted } from "@mdi/js"
import { SearchState } from "react-instantsearch-core"

import NumberOfResults from "components/Algolia/NumberOfResults"
import SortResults from "components/Algolia/SortResults"
import ChangePage from "components/Algolia/ChangePage"

import MobileFilters from "components/Algolia/Filters/MobileFilters"
import { FilterConfig } from "@secureo/common/typings/Algolia"

const useStyles = makeStyles()((theme: any) => ({
	toggleResultsViewBreakPoint: {
		display: "block",
		[theme.breakpoints.down("lg")]: {
			display: "none",
		},
	},
}))

const ToggleResultsView = ({ toggleIsListView }: Pick<Props, "toggleIsListView">) => {
	return (
		<Box mr={1}>
			<IconButton onClick={toggleIsListView} size="small" style={{ marginRight: 0 }}>
				<Icon path={mdiViewGrid} size={1} color="black" />
			</IconButton>
			<IconButton onClick={toggleIsListView} size="small">
				<Icon path={mdiFormatListBulleted} size={1} color="black" />
			</IconButton>
		</Box>
	)
}

const ResultsHeader = ({
	indexName,
	toggleIsListView,
	filters,
	virtualRefinements = {},
	totalNumberOfResults,
}: Props) => {
	const { classes } = useStyles()

	return (
		<>
			<Box style={{ display: "flex", justifyContent: "space-between" }}>
				<Hidden mdUp>
					<div>
						<MobileFilters
							totalNumberOfResults={totalNumberOfResults}
							filters={filters}
							virtualRefinements={virtualRefinements}
						/>
					</div>
				</Hidden>
				<Hidden mdUp>
					<NumberOfResults totalNumberOfResults={totalNumberOfResults} />
				</Hidden>
			</Box>
			<Box
				mt={1}
				style={{
					background: "#E3E5E6",
					borderRadius: 8,
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					paddingLeft: 8,
					paddingRight: 8,
					paddingTop: 2,
					paddingBottom: 4,
				}}
			>
				<div style={{ display: "flex", alignItems: "center" }}>
					<div className={classes.toggleResultsViewBreakPoint}>
						<ToggleResultsView toggleIsListView={toggleIsListView} />
					</div>
					<div>
						<SortResults indexName={indexName} />
					</div>
				</div>

				<div style={{ display: "flex", alignItems: "center", float: "right" }}>
					<Hidden smDown>
						<NumberOfResults totalNumberOfResults={totalNumberOfResults} />
						<Box mx={1} style={{ color: "#505e5f" }}>
							|
						</Box>
					</Hidden>
					<ChangePage />
				</div>
			</Box>
		</>
	)
}

interface Props {
	toggleIsListView: () => void
	indexName: string
	totalNumberOfResults: number
	filters: FilterConfig[]
	virtualRefinements?: SearchState
}

export default ResultsHeader
